import React, { useEffect, useState } from 'react'
import camera from "../dist/webImages/camera.svg"
import profile from "../dist/webImages/profile.webp"
import usePost from '../customHooks/usePost';
import { toast } from 'react-toastify';
import swal from "sweetalert";

const OneImageUploadMultiple = ({Update,changeImage,section,indexValue,sec_image,sec_value,folder_name,page_type,MainImage}) => {
    const [res2, apiMethod2] = usePost();
    const [imageLoader, setImageLoader] = useState(false)



    const handleDrop2 = (e) => {
        changeImage(true)
        setImageLoader(true)
        let formdata = new FormData();
        if (e.dataTransfer.files[0] && e.dataTransfer.files[0]?.type?.includes("image")) {
            let path = (window.URL || window.webkitURL).createObjectURL(e.dataTransfer.files[0]);
            const file = e.dataTransfer.files[0];
            Update(prevService => ({
                ...prevService,
                [section]: prevService[section].map((item,index2) =>
                  index2 === indexValue ? { ...item, [sec_image]: path } : item
              )
            }));
            formdata.append(`image`, e.dataTransfer.files[0]);
            formdata.append(`folder_name`, folder_name);
            formdata.append(`page_type`, page_type);
            apiMethod2(`innerPages/uploadImage`, formdata)

        } 
        else {
            swal("Only use Image", "", "warning");
        }
    };
    const handleFileUpload2 = (e) => {
        changeImage(true)
        setImageLoader(true)
        let formdata = new FormData();
        const file = e.target.files[0];
        if (file) {
            let path = (window.URL || window.webkitURL).createObjectURL(file);
            Update(prevService => ({
                ...prevService,
                [section]: prevService[section].map((item,index2) =>
                  index2 === indexValue ? { ...item, [sec_image]: path } : item
              )
            }));
            formdata.append(`image`, file);
            formdata.append(`folder_name`, folder_name);
            formdata.append(`page_type`, page_type);
            apiMethod2(`innerPages/uploadImage`, formdata)
        }
    }

  useEffect(() => {
    if (res2.data) {
      const { status, message,data } = res2?.data
      if (status === "false") {
        toast.error(message);
      }
      else {
        Update(prevService => ({
            ...prevService,
            [section]: prevService[section].map((item,index2) =>
              index2 === indexValue ? { ...item, [sec_value]: data?.image_path } : item
          )
        }))
        changeImage(false)
        setImageLoader(false)
      }
    }
  }, [res2.data])

    return (
        <>
            {imageLoader ?
                <div className=' h-[10rem] w-full relative bg-[#fff] grid place-items-center'>
                    <div className="TeamBoxinput w-[3rem] h-[3rem] grid place-items-center">
                        <div role="status " className="">
                            <svg  className="w-10 h-10 ml-auto text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                            </svg>
                        </div>
                    </div>
                </div>
                :
                <div>
                    <div className=' h-[10rem] relative' onDrop={(e) => handleDrop2(e)}>
                        {MainImage ?
                            <img src={MainImage || profile} className='w-full h-full rounded-3xl object-cover ' alt="" />
                            :
                            <div className='w-full h-full  rounded-3xl object-cover  bg-white'></div>
                        }
                        <div className="TeamBoxinput w-[3rem] h-[3rem] bg-[#C0CCE2] grid  place-items-center rounded-full absolute mx-auto right-0 left-0 top-[50%] transform translate-y-[-50%] cursor-pointer z-1">
                            <input type="file" onChange={(e) => handleFileUpload2(e)} className='absolute inset-0 opacity-0 cursor-pointer' />
                            <img src={camera} alt="camera" className='cursor-pointer w-full p-3' />
                        </div>
                    </div>
                </div>}
        </>
    )
}

export default OneImageUploadMultiple